import DashBoard from "../view/listings/DashBoard";
import User from "../view/listings/User";
import Company from "../view/listings/Company";
import Category from "../view/listings/Category";
import Member from "../view/listings/Member";
import Staff from "../view/listings/Staff";
import ProductAndService from "../view/listings/ProductAndService";
import Billing from "../view/listings/Billing";
import CompanyCreation from "../view/creations/CompanyCreation";
import CategoryCreation from "../view/creations/CategoryCreation";
import MemberCreation from "../view/creations/MemberCreation";
import StaffCreation from "../view/creations/StaffCreation";
import ProductAndServiceCreation from "../view/creations/ProductAndServiceCreation";
import BillingCreation from "../view/creations/BillingCreation";
import Login from "../view/Login";
import Expense from "../view/listings/Expense";
import ExpenseCreation from "../view/creations/ExpenseCreation";
import ExpenseReport from "../view/listings/ExpenseReport";

const routes = [
  { path: "/", component: Login },
  { path: "/dashboard", component: DashBoard },
  { path: "/users", component: User },

  // ---- company routes ----
  { path: "/company", component: Company },
  { path: "/company/create", component: CompanyCreation },
  { path: "/company/edit/:id", component: CompanyCreation },

  // ---- category routes ----
  { path: "/category", component: Category },
  { path: "/category/create", component: CategoryCreation },
  { path: "/category/edit/:id", component: CategoryCreation },

  // ---- member routes ----
  { path: "/member", component: Member },
  { path: "/member/create", component: MemberCreation },
  { path: "/member/edit/:id", component: MemberCreation },

  // <-- new staff routes
  { path: "/staff", component: Staff },
  { path: "/staff/create", component: StaffCreation },
  { path: "/staff/edit/:id", component: StaffCreation },

  // <-- new productandservice routes
  { path: "/productandservice", component: ProductAndService },
  { path: "/productandservice/create", component: ProductAndServiceCreation },
  { path: "/productandservice/edit/:id", component: ProductAndServiceCreation },

  // <-- new billing routes
  { path: "/billing", component: Billing },
  { path: "/billing/create", component: BillingCreation },
  { path: "/billing/edit/:id", component: BillingCreation },

  // <-- new expense routes
  { path: "/expense", component: Expense },
  { path: "/expense/create", component: ExpenseCreation },
  { path: "/expense/edit/:expenseId", component: ExpenseCreation },
  { path: "/expense-report", component: ExpenseReport },
];

export default routes;
